import BaseEvent, { BaseGetEvent, IBaseEvent } from './BaseEvent';

export interface ICheckboxEvent extends IBaseEvent {
  type: 'checkbox';
  toJSON(): BaseGetEvent & {
    type: ICheckboxEvent['type'];
    checkboxChecked: boolean;
  };
}

export default class CheckboxEvent extends BaseEvent implements ICheckboxEvent {
  type = 'checkbox' as const;

  private checkboxChecked: boolean;
  private content: string | undefined;

  constructor({
    description,
    checkboxChecked,
    content,
  }: {
    description: string | undefined;
    checkboxChecked: boolean;
    content?: string;
  }) {
    super(description);
    this.checkboxChecked = checkboxChecked;
    this.content = content;
  }

  toJSON() {
    return {
      ...super.toJSON(),
      type: this.type,
      checkboxChecked: this.checkboxChecked,
      content: this.content,
    };
  }
}
